// @flow

import React from 'react';
export function SetupIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9737 4.08502C13.9482 3.90602 13.8253 3.75917 13.6531 3.70182C13.4806 3.6443 13.2938 3.68818 13.1656 3.81633L12.5322 4.4497C12.4527 4.52913 12.3463 4.57255 12.2353 4.57264C12.1243 4.57246 12.0201 4.52904 11.9412 4.4497L11.5518 4.06028C11.4724 3.98077 11.4287 3.87533 11.4289 3.76338C11.429 3.65236 11.4725 3.54829 11.5523 3.46905L12.1852 2.83412C12.3118 2.70752 12.3563 2.52284 12.3014 2.35218C12.2461 2.18069 12.1013 2.05611 11.9235 2.02716L11.9186 2.02633C11.1553 1.91283 10.3741 2.17052 9.82814 2.71632C9.28726 3.25945 9.03432 4.00605 9.13427 4.76575C9.15626 4.92927 9.09937 5.09681 8.9821 5.21407L2.37288 11.8224C1.87653 12.3186 1.87562 13.1269 2.37068 13.6242C2.61153 13.8662 2.93208 13.9996 3.27342 14H3.27498C3.61568 14 3.93605 13.8674 4.17708 13.6264L10.7852 7.01919C10.9026 6.90175 11.0702 6.84477 11.2346 6.86703C11.9935 6.96688 12.7402 6.71404 13.2839 6.17265C13.8293 5.6274 14.0871 4.84618 13.9737 4.08502Z"
        fill="#8C9196"
      />
      <path
        d="M2.78536 5.31593C2.83109 5.41875 2.90175 5.50125 2.98978 5.55446L4.42639 6.42309L5.78132 8L7.14286 6.4067L5.78925 4.83L5.0461 3.15378C5.00037 3.05066 4.92952 2.96795 4.84114 2.91453L3.42876 2.0626C3.24364 1.95081 3.02009 1.99134 2.87268 2.16336L2.14071 3.01704C1.99242 3.18998 1.95761 3.45213 2.0541 3.66952L2.78536 5.31593Z"
        fill="#8C9196"
      />
      <path
        d="M10.4683 8L8 10.4752L11.0166 13.4893C11.3573 13.8297 11.8047 14 12.2521 14C12.6997 14 13.1472 13.8296 13.4879 13.4891C13.8182 13.1589 14.0001 12.7197 14 12.2526C13.9999 11.7855 13.8179 11.3465 13.4875 11.0163L10.4683 8Z"
        fill="#8C9196"
      />
    </svg>
  );
}
